const ItemGenerator = require('../../../game_items/ItemGenerator.js');
const MedTorsoe = require('../../../game_items/equipment/torsoe/MedTorsoe.js');
const LightBoots = require('../../../game_items/equipment/boots/LightBoots.js');
const Staff = require('../../../game_items/equipment/weapon/Staff.js');
const getMobEquipmenAssignmentFromBags = require('./getMobEquipmenAssignmentFromBags');

const goblin = (level) => {
  const handle = 'goblin';
  const types = ['goblin', 'humanoid'];
  const AI_PRIORITIES = ['interference', 'dps_close', 'tank', 'support', 'dps_ranged'];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(MedTorsoe, level),
          ItemGenerator.getCavernsMobItem(LightBoots, level),
          ItemGenerator.getCavernsMobItem(Staff, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'goblin_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          ice_nine: {
            handle: 'ice_nine',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          road_to_nowhere: {
            handle: 'road_to_nowhere',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(5 + bound_level * 0.65 + Math.random() * 3),
      perception: Math.round(6 + bound_level * 0.6 + Math.random() * 3),
      mana: Math.round(4 + bound_level * 0.5 + Math.random() * 3),
      toughness: Math.round(4 + bound_level * 0.45 + Math.random() * 3),
      strength: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
      willpower: Math.round(5 + bound_level * 0.7 + Math.random() * 3),
      dexterity: Math.round(7 + bound_level * 0.9 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 500,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities: [
        { value: 'move' },
        { value: 'melee_attack' },
        { value: 'ice_nine' },
        { value: 'road_to_nowhere' },
      ],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = goblin;
